module.exports = __webpack_public_path__ + "static/media/HSERIES.721d1a17.pdf";